var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTailored({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 12,
    fill: "#DDD2FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.6294 12.8L29.4337 26.0744L35.3334 27.1396L22.7965 43.2L26.6477 30.4172L20.666 29.352L32.6294 12.8Z",
    fill: "#4B1598"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTailored);
export default __webpack_public_path__ + "static/media/tailored.7aee30a9b12b719205b6046e6da04e67.svg";
export { ForwardRef as ReactComponent };